Object.defineProperty(exports, "__esModule", {
  value: true,
});

const VENDOR_PREFIX = /^(moz|ms|o|webkit)-/;

const NUMERIC_STRING = /^\d+$/;
const UPPERCASE_PATTERN = /([A-Z])/g;

// Lifted from:
// https://github.com/facebook/react/blob/ab4ddf64939aebbbc8d31be1022efd56e834c95c/src/renderers/dom/shared/CSSProperty.js
const isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true,
};

// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/CSSPropertyOperations.js
function processStyleName(name) {
  return name
    .replace(UPPERCASE_PATTERN, "-$1")
    .toLowerCase()
    .replace(VENDOR_PREFIX, "-$1-");
}

// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/dangerousStyleValue.js
function processStyleValue(name, value) {
  // eslint-disable-next-line no-void
  let isNumeric = void 0;
  if (typeof value === "string") {
    isNumeric = NUMERIC_STRING.test(value);
  } else {
    isNumeric = true;
    value = String(value);
  }
  if (!isNumeric || value === "0" || isUnitlessNumber[name] === true) {
    return value;
  }
  return `${value}px`;
}

function styleToCSS(styleDescr) {
  return Object.keys(styleDescr)
    .map(name => {
      const styleValue = processStyleValue(name, styleDescr[name]);
      const styleName = processStyleName(name);
      return `${styleName}: ${styleValue}`;
    })
    .join("; ");
}

exports.default = styleToCSS;



// WEBPACK FOOTER //
// ./src/components/CustomRevvEditor/helpers/styleToCSS.js